module.exports = __webpack_public_path__ + "static/media/play.348b07f2.svg";